import TuevsRepository from "@/repositories/tuevs/TuevsRepository";
import component from '@/storages/tuevs/ComponentStore'
import exams from '@/storages/tuevs/ExamStore'
import material from '@/storages/tuevs/MaterialStore'
import complement from '@/storages/tuevs/ComplementStore'
import method from '@/storages/tuevs/MethodStore'
import scale from '@/storages/tuevs/ScaleStore'
import time from '@/storages/tuevs/TimeStore'
import examresult from '@/storages/tuevs/ExamResultStore'

let StatusRowVariantRef = {
    'nao_salvo': 'warning',
    'importado': 'info',
    'salvo': 'success',

};

function translateStatusToVariant(item) {
    item._rowVariant = StatusRowVariantRef[item.status];
    item.statusOrder = Object.keys(StatusRowVariantRef).indexOf(item.status);
    return item;
}

export default {
    name: 'tuevs',
    namespaced: true,
    state: {
        can_show_table: false,
        showImportMessage: null,
        customer_list: [],
        integration_list: [],
        exams_to_sync: [],
        tuevs_exams: [],
        mocked_exams: [
            {
                id: 1,
                mnemonico_exame_cliente: 'LYME',
                nome_exame_cliente: 'BORRELIA BURGDORFERI (Doença de Lyme) IgG e IgM',
                mnemonico_sub_exame_cliente: '',
                nome_sub_exame_cliente: '',

                mnemonico_exame_integracao: 'BORGC',
                nome_exame_integracao: '',
                mnemonico_sub_exame_integracao: '',
                nome_sub_exame_integracao: '',

                mnemonico_material_cliente: '5210',
                nome_material_cliente: 'Soro',
                nome_metodo_cliente: '',
                mnemonico_metodo_cliente: '',
                sinonimia: ['Doença de Lyme', 'Borreliose', 'carrapato'],
                status: 'importado',
                _rowVariant: 'success'
            },
            {
                id: 2,
                mnemonico_exame_cliente: 'NILO',
                nome_exame_cliente: 'Febre do Nilo Ocidental - PCR do RNA do Flavivirus',
                mnemonico_sub_exame_cliente: '',
                nome_sub_exame_cliente: '',

                mnemonico_exame_integracao: 'FLAVG',
                nome_exame_integracao: 'MOSAIC SOROLOGIA FLAVIVIRUS IGG',
                mnemonico_sub_exame_integracao: '',
                nome_sub_exame_integracao: '',

                mnemonico_material_cliente: '',
                nome_material_cliente: '',
                nome_metodo_cliente: '',
                mnemonico_metodo_cliente: '',
                sinonimia: ['West Nile Virus RNA', 'Qualitative'],
                status: 'salvo',
                _rowVariant: 'info'


            },
            {
                id: 3,
                mnemonico_exame_cliente: '5HTPUR',
                nome_exame_cliente: '5-HIDROXITRIPTOFANO - urina 24h',
                mnemonico_sub_exame_cliente: 13440,
                nome_sub_exame_cliente: 'Volume urinário',

                mnemonico_exame_integracao: '5HTR',
                nome_exame_integracao: '5-HIDROXITRIPTOFANO',
                mnemonico_sub_exame_integracao: 'VOL',
                nome_sub_exame_integracao: 'VOLUME',

                mnemonico_material_cliente: '',
                nome_material_cliente: '',
                nome_metodo_cliente: '',
                mnemonico_metodo_cliente: '',
                sinonimia: [],
                status: 'atencao',
                _rowVariant: 'warning'

            },
            {
                id: 4,
                mnemonico_exame_cliente: '5HTPUR',
                nome_exame_cliente: '5-HIDROXITRIPTOFANO - urina 24h',
                mnemonico_sub_exame_cliente: 16076,
                nome_sub_exame_cliente: '5-Hidroxitriptofano 24 horas - Concentração',

                mnemonico_exame_integracao: '5HTR',
                nome_exame_integracao: '5-HIDROXITRIPTOFANO',
                mnemonico_sub_exame_integracao: 'CONC',
                nome_sub_exame_integracao: 'CONCENTRAÇÃO',

                mnemonico_material_cliente: '',
                nome_material_cliente: '',
                nome_metodo_cliente: '',
                mnemonico_metodo_cliente: '',
                sinonimia: [],
                status: 'atencao',
                _rowVariant: 'warning'
            },
            {
                id: 5,
                mnemonico_exame_cliente: '5HTPUR',
                nome_exame_cliente: '5-HIDROXITRIPTOFANO - urina 24h',
                mnemonico_sub_exame_cliente: 13439,
                nome_sub_exame_cliente: '5-HIDROXITRIPTOFANO - urina 24h',

                mnemonico_exame_integracao: '5HTR',
                nome_exame_integracao: '5-HIDROXITRIPTOFANO',
                mnemonico_sub_exame_integracao: '5HTR',
                nome_sub_exame_integracao: 'RESULTADO',

                mnemonico_material_cliente: '',
                nome_material_cliente: '',
                nome_metodo_cliente: '',
                mnemonico_metodo_cliente: '',
                mnemonico_suporte: '',
                sinonimia: [],
                status: 'atencao',
                _rowVariant: 'warning'
            }
        ],
        main_table_fields: [
            {
                key: 'status',
                label: 'Status'
            },
            {
                key: "mnemonico_exame",
                label: "Mnemônico Exame"
            },
            {
                key: "nome_exame",
                label: "Nome do Exame"
            },
            {
                key: "nome_sub_exame",
                label: "Nome do Sub-exame"
            },
            {
                key: "nome_material",
                label: "Nome do Material"
            },
            {
                key: "nome_metodo",
                label: "Nome do método"
            },
            {
                key: "mnemonico_exame_tuevs",
                label: "Mnemônico Exame Suporte"
            },
            {
                key: "nome_exame_integracao",
                label: "Nome do Exame Suporte"
            },
            {
                key: "acao",
                label: "Acao"
            },

        ],
        row_detail_table_fields: [


            {
                key: "mnemonico_material",
                label: "Mnemônico do Material"
            },
            {
                key: "mnemonico_metodo",
                label: "Mnemônico do método"
            }
        ],
        row_detail_integration_fields: [
            {
                key: "mnemonico_exame_suporte",
                label: "Mnemônico Exame"
            },
            {
                key: "mnemonico_sub_exame_suporte",
                label: "Mnemônico Sub-exame"
            },
            {
                key: "nome_sub_exame_suporte",
                label: "Nome do Sub-exame"
            }
        ],
        integracoes_clientes: [
            {value: null, text: 'Selecione novo laboratório:'},
        ],
        integracoes_suportes: [
            {value: null, text: 'Selecione laboratório já integrado:'},
        ],
    },
    getters: {
        getExamsToSync(state) {
            return state.exams_to_sync.sort((a, b) => a.statusOrder > b.statusOrder)
        },
        getTuevsExams(state) {
            return state.tuevs_exams
        },
        getMockedExams(state) {
            return state.mocked_exams
        },
        getMainTableFields(state) {
            return state.main_table_fields
        },
        getRowDetailsFields(state) {
            return state.row_detail_table_fields
        },
        getIntegrationRowDetails(state) {
            return state.row_detail_integration_fields
        },
        getCanShowTable(state) {
            return state.can_show_table
        },
        getCompanies(state) {
            return state.integracoes_clientes
        },
        getSupportCompanies(state) {
            return state.integracoes_suportes
        },
        getImportMessage(state) {
            return state.showImportMessage
        }
    },
    mutations: {
        setExamsToSync(state, object) {
            state.exams_to_sync = [...state.exams_to_sync, object];
        },
        setCanShowTable(state, object) {
            state.can_show_table = object
        },
        setCompanies(state, object) {
            state.integracoes_clientes = [...state.integracoes_clientes, object]
        },
        setSupportCompanies(state, object) {
            state.integracoes_suportes = [...state.integracoes_suportes, object]
        },
        setTuevsExams(state, object) {
            state.tuevs_exams = [...state.tuevs_exams, object]
        },
        updateExam(state, object) {
            let index = state.exams_to_sync.findIndex(
                x => x.mnemonico_exame === object.mnemonico_exame
            );
            state.exams_to_sync[index] = object
        },
        showImportMessage(state, object) {
            state.showImportMessage = object;
        }
    },
    actions: {

        updateExam({commit, state}, exam_id) {
            TuevsRepository.updateExam(exam_id)
                .then(result => {
                    commit("updateExam", result.data.data.exam);
                });
        },

        mapExamToTuevs({dispatch, commit, state}, {mapped_exam_id, tuevs_id}) {

            TuevsRepository.mapExamToTuevs(mapped_exam_id, tuevs_id)
                .then(result => {
                    dispatch('updateExam', result.data.data.mapped_exam_id);
                    return result.data.status;
                })
        },

        importExams({commit, state}, {company_id, support_lab_id, data}) {
            TuevsRepository.sendImportData(company_id, support_lab_id, data)
                .then(result => {

                    commit("showImportMessage", null);

                    if (result.data.data.message) {
                        commit("setCanShowTable", false);
                        commit("showImportMessage", result.data.data.message);
                        return;
                    }

                    result.data.data.forEach(item => {
                        item = translateStatusToVariant(item);
                        commit("setExamsToSync", item);
                    });

                    commit("setCanShowTable", true);

                })
        },

        getTuevsExams({commit, state}, keyword) {
            TuevsRepository.getTuevsExams(keyword)
                .then(result => {
                    result.data.data.forEach(item => {
                        commit('setTuevsExams', {
                            code: item.id,
                            label: item.name
                        })
                    })
                })
        },

        getCompanies({commit, state}, params) {
            TuevsRepository.getCompanies(params)
                .then(result => {
                    result.data.forEach(item => {
                        commit("setCompanies", {
                            value: item.id,
                            text: item.name
                        })

                    })
                })

        },

        getSupportCompanies({commit, state}, params) {
            TuevsRepository.getSupportCompanies()
                .then(result => {

                    result.data.forEach(item => {
                        commit("setSupportCompanies", {
                            value: item.id,
                            text: item.name
                        })
                    })
                })
        },


    },

    modules: {
        component,
        material,
        complement,
        method,
        time,
        scale,
        exams,
        examresult
    }
}
